import { PATHS } from "../routes";

/**
 * Determines if the given pathname represents the landing page.
 * Accounts for both the default route path and deploy-time base path.
 */
const normalizePath = (path: string): string => {
  if (!path) {
    return "";
  }

  if (path === "/") {
    return "/";
  }

  return path.endsWith("/") ? path.slice(0, -1) : path;
};

const getLandingPathCandidates = (): string[] => {
  const configuredBasePath = normalizePath(window.__BASEPATH__ || "");
  const baseCandidates = [
    normalizePath(PATHS.landing),
    configuredBasePath,
  ].filter(Boolean);

  return Array.from(new Set(baseCandidates));
};

export const isLandingPath = (pathname: string): boolean => {
  const normalizedPathname = normalizePath(pathname);
  return getLandingPathCandidates().includes(normalizedPathname);
};
